export default "__VITE_ASSET__DngpdTTL__"